var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{ref:"container",tag:"component",on:{"click":function($event){return _vm.$emit('ob-click', $event)},"mouseenter":function($event){return _vm.$emit('hover', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }